module.exports = __webpack_public_path__ + "static/media/features-split-image-02.30f4a3f5.png";